// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-grey-text.dark-grey-text-bold .card-header-text {
  font-size: 15px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/grants/grants-registrations/grants-registrations-view-modal/grants-registrations-view-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;AACJ","sourcesContent":[".dark-grey-text.dark-grey-text-bold .card-header-text {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
